import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { pendingJourneysRoute } from '@atlassian/jira-router-routes-journeys-routes/src/pendingJourneysRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { journeysPageEntryPoint } from './ui/index.tsx';

export const pendingJourneysRouteEntry: Route = createEntry(pendingJourneysRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.journeys',
	component: () => null,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () => journeysPageEntryPoint,

	meta: {
		reporting: {
			id: 'journeys',
			packageName: toPackageName(APP_NAMES.JOURNEYS),
			teamName: 'JSM Getting Started',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-journeys-entries/src/pendingJourneysRouteEntry.tsx',
			whichExportToUse: 'pendingJourneysRouteEntry',
		},

		enabled: true,
	},
}));
